import { createAPI } from '../../composable/useAPI';

export const useStorageAPI = () =>{
  const api = createAPI();

  const request = {
    storage: {
      get: async (params) => {
        return await api.get('/api/v2/session/storage', { params })
          .then((res) => { return res.data.data })
          .catch (err => { console.error(err); return false })
      },
      add: async (data) => {
        return await api.put('/api/v2/session/storage/add', data)
          .then((res) => { return res.data.status === 200 })
          .catch (err => { console.error(err); return false })
      },
      delete: async (data) => {
        return await api.put('/api/v2/session/storage/delete', data)
          .then((res) => { return res.data.status === 200 })
          .catch (err => { console.error(err); return false })
      },
    }
  };

  return {
    ...request
  };
}
